var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 561,
    viewBox: "0 0 563 561",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.558 560.096c155.177 0 280.971-125.173 280.971-279.576C281.529 126.118 155.752.95.559.95v559.146zM281.529 560.096c155.176 0 280.971-125.173 280.971-279.576C562.5 126.118 436.723.95 281.529.95v559.146z",
    fill: "#fff"
  })));
}
export default SvgOfferLeft;